import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Properties from './pages/prop';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Properties />
  </React.StrictMode>
);

